<template>
  <div class="ColumnChart">
    <GChart         
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions" />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import { numberWithDots } from '@/helpers/number'

export default {
  name: 'ColumnChart',
  components: { GChart },
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          title: 'Laadpaal behoefte',
        },
        isStacked: true,
        legend: { position: 'right', textStyle: { color: '#7F7F7F' } },
        hAxis: { textStyle: { bold: true, color: '#7F7F7F' } },
        vAxis: { format: '#.###' },
        bar: { groupWidth: "80%" },
        colors: [
          '#E4EDF5',
          '#689AC5',
          '#3B547B',
        ],
        height: 237,
        width: 475,
        chartArea: { left: 50, right: 125 },
        focusTarget: 'category',
        animation: {
          duration: 500
        }
      }
    }
  },
  computed: {
    chartData() {
      let chartSerieLabels = [
        'Jaar', 
        'Bewoners', 'Forenzen', 'Bezoekers', 
        { role: 'annotation' },
      ]
      let data = [
        chartSerieLabels
      ]

      this.data.forEach(entry => {
        data.push([
          entry[0][0], entry[1][0], entry[1][1], entry[1][2], numberWithDots(entry[1][3])
        ])
      })
      
      return data
    }
  }
}
</script>

<style>

</style>